import { render, staticRenderFns } from "./unionOrdersLifes.vue?vue&type=template&id=3437a29e&scoped=true&"
import script from "./unionOrdersLifes.vue?vue&type=script&lang=js&"
export * from "./unionOrdersLifes.vue?vue&type=script&lang=js&"
import style0 from "./unionOrdersLifes.vue?vue&type=style&index=0&lang=less&"
import style1 from "./unionOrdersLifes.vue?vue&type=style&index=1&id=3437a29e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3437a29e",
  null
  
)

component.options.__file = "unionOrdersLifes.vue"
export default component.exports